// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-swatch-label[data-v-ad065fb4] {
  display: inline-flex;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid var(--i-color-border, #d9d9d9);
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
}
.color-swatch-input[data-v-ad065fb4] {
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/questionnaire/QuestionnaireColorPickerList.vue","webpack://./QuestionnaireColorPickerList.vue"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ACDJ;ADIA;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;ACDJ","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.color-swatch-label {\n    display: inline-flex;\n    width: 44px;\n    height: 44px;\n    border-radius: 8px;\n    border: 1px solid var(--i-color-border, #d9d9d9);\n    cursor: pointer;\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n.color-swatch-input {\n    width: 100%;\n    height: 100%;\n    border: 0;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n    opacity: 0;\n}\n",".color-swatch-label {\n  display: inline-flex;\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid var(--i-color-border, #d9d9d9);\n  cursor: pointer;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.color-swatch-input {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
